(function () {
  /* Glasses LA — custom "< Back" pill; mounted on modal root, survives step re-renders */
  var pollId = null;
  var modalObserver = null;
  var resizeHandler = null;

  function isGlassesHost() {
    if (window.ciwLaHostApi && window.ciwLaHostApi.isContactLens && window.ciwLaHostApi.isContactLens()) {
      return false;
    }
    return !!document.querySelector('.ciw-pdp') && !document.querySelector('.cl-section');
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getModal() {
    return document.getElementById('lensadvizor-prescription-modal');
  }

  function getNativeBack(modal) {
    if (!modal) return null;
    return modal.querySelector('.la-steeper-back');
  }

  function hideNativeBack(back) {
    if (!back) return;
    back.classList.add('ciw-la-gusa-back-native');
    back.setAttribute('aria-hidden', 'true');
  }

  function restoreNativeBack(back) {
    if (!back) return;
    back.classList.remove('ciw-la-gusa-back-native');
    back.removeAttribute('aria-hidden');
  }

  function removeCustomBack(modal) {
    if (!modal) return;
    var custom = modal.querySelector(':scope > .ciw-la-gusa-back-btn');
    if (custom) custom.remove();
  }

  function isColorStepActive() {
    return document.body.classList.contains('ciw-la-lens-color-continue-active');
  }

  function getColorStepScope(contentBody) {
    if (!contentBody) return null;
    return contentBody.querySelector('.la-choose-prescription-wrapper.ciw-la-lens-color-step');
  }

  function isVisibleTitleEl(el) {
    if (!el || el.closest('[hidden], .ciw-la-manual-rx-hidden')) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getColorStepCardRect(contentBody) {
    if (!isColorStepActive() || !contentBody) return null;

    var scope = getColorStepScope(contentBody);
    if (!scope) return null;

    var card =
      scope.querySelector('.la-label-btn-wrapper:not([hidden])') ||
      scope.querySelector('.la-horizontal-boxy-label-wrapper:not([hidden])') ||
      scope.querySelector('.la-label-btn-wrapper') ||
      scope.querySelector('.la-horizontal-boxy-label-wrapper');
    if (!card) return null;

    var rect = card.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect : null;
  }

  function getColorStepTitleAlignEl(modal, contentBody) {
    var titleEl = getStepTitleElement(modal);
    if (!titleEl || !contentBody) return null;
    return titleEl;
  }

  function clearColorStepTitleAlign(contentBody) {
    if (!contentBody) return;

    var nudged = contentBody.querySelectorAll('[data-ciw-la-color-title-nudge="1"]');
    var i;
    for (i = 0; i < nudged.length; i++) {
      nudged[i].style.removeProperty('transform');
      nudged[i].removeAttribute('data-ciw-la-color-title-nudge');
    }
  }

  function syncColorStepTitleAlign(modal, contentBody) {
    if (!isColorStepActive()) {
      clearColorStepTitleAlign(contentBody);
      return;
    }

    var cardRect = getColorStepCardRect(contentBody);
    if (!cardRect) return;

    var alignEl = getColorStepTitleAlignEl(modal, contentBody);
    if (!alignEl) return;

    clearColorStepTitleAlign(contentBody);

    var alignRect = alignEl.getBoundingClientRect();
    if (alignRect.width <= 0 || alignRect.height <= 0) return;

    var delta = Math.round(cardRect.left - alignRect.left);
    if (Math.abs(delta) < 1) {
      return;
    }

    alignEl.style.setProperty('transform', 'translateX(' + delta + 'px)', 'important');
    alignEl.setAttribute('data-ciw-la-color-title-nudge', '1');
  }

  function getStepTitleElement(modal) {
    var contentBody = modal && modal.querySelector('.la-prescription-modal-content-body');
    if (!contentBody) return null;

    var reviewScope = contentBody.querySelector('.la-choose-prescription-wrapper.la-render-review');
    if (reviewScope) {
      var reviewTitle =
        reviewScope.querySelector('#la_prescriptionSelect_title') ||
        reviewScope.querySelector('.la-wrapper-heading h3');
      if (isVisibleTitleEl(reviewTitle)) {
        return reviewTitle;
      }
    }

    if (isColorStepActive()) {
      var colorScope = getColorStepScope(contentBody);
      if (colorScope) {
        var colorTitle =
          colorScope.querySelector('#la_prescriptionSelect_title') ||
          colorScope.querySelector('.la-wrapper-heading h3');
        if (isVisibleTitleEl(colorTitle)) {
          return colorTitle;
        }
      }
    }

    var candidates = contentBody.querySelectorAll(
      '.la-wrapper-heading h3, #la_prescriptionSelect_title, .ciw-la-manual-rx-heading__title'
    );

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (!isVisibleTitleEl(candidate)) {
        continue;
      }

      if (isColorStepActive() && candidate.closest('.la-choose-prescription-wrapper.ciw-la-lens-color-step')) {
        return candidate;
      }

      if (isColorStepActive()) {
        continue;
      }

      return candidate;
    }

    return null;
  }

  function getReviewCardRect(modal) {
    if (!modal) return null;
    var card = modal.querySelector(
      '.la-choose-prescription-wrapper.la-render-review .ciw-la-review-card'
    );
    if (!card) return null;
    var rect = card.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? rect : null;
  }

  function getMobileCardGutter() {
    return 18;
  }

  function isFullBleedCardRect(rect) {
    return !!(rect && rect.left <= 2);
  }

  function getMobileInsetRight(modal, contentBody, cardRect) {
    if (cardRect && !isFullBleedCardRect(cardRect)) {
      return cardRect.right;
    }

    if (!contentBody) {
      return null;
    }

    var bodyRect = contentBody.getBoundingClientRect();
    if (bodyRect.width <= 0) {
      return null;
    }

    return bodyRect.right - getMobileCardGutter();
  }

  function getMobileInsetLeft(modal, contentBody, cardRect) {
    if (cardRect && !isFullBleedCardRect(cardRect)) {
      return cardRect.left;
    }

    if (!contentBody) {
      return getMobileCardGutter();
    }

    var bodyRect = contentBody.getBoundingClientRect();
    if (bodyRect.width <= 0) {
      return getMobileCardGutter();
    }

    return bodyRect.left + getMobileCardGutter();
  }

  function getFallbackLeft(modal, bodyRect, isMobile) {
    var gutter = isMobile ? 16 : 18;

    if (
      isMobile &&
      (isColorStepActive() ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-review') ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)') ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-addons'))
    ) {
      gutter = 18;
    }

    if (
      !isMobile &&
      (isColorStepActive() ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)') ||
        modal.querySelector('.la-choose-prescription-wrapper.la-render-addons') ||
        modal.querySelector('#la-prescription-form.ciw-la-manual-rx-form--mobile') ||
        modal.querySelector('#la-prescription-form.ciw-la-upload-rx-form--mobile'))
    ) {
      gutter = 35;
    }

    return bodyRect.left + gutter;
  }

  function getModalClose() {
    var header = document.getElementById('la-prescription-modal-header');
    if (header) {
      var closeInHeader = header.querySelector('.la-prescription-modal-close');
      if (closeInHeader) {
        return closeInHeader;
      }
    }

    var modal = getModal();
    return modal ? modal.querySelector('.la-prescription-modal-close') : null;
  }

  function restoreClosePosition() {
    var close = getModalClose();
    if (close) {
      close.style.removeProperty('top');
      close.style.removeProperty('left');
      close.style.removeProperty('right');
      close.style.removeProperty('position');
      close.style.removeProperty('z-index');
    }
  }

  function restoreCloseChrome() {
    var close = getModalClose();
    if (!close) {
      return;
    }

    close.classList.remove('ciw-la-gusa-close-btn');
    close.style.removeProperty('display');
    restoreClosePosition();
  }

  function isTransitionsDrawerActive() {
    return document.body.classList.contains('ciw-la-transitions-drawer-active');
  }

  function shouldHideChromeForTransitionsDrawer() {
    return isTransitionsDrawerActive() && isMobileViewport();
  }

  function syncCloseChrome() {
    if (isMobileViewport() && !isGlassesHost()) {
      restoreCloseChrome();
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    close.classList.add('ciw-la-gusa-close-btn');
    if (shouldHideChromeForTransitionsDrawer()) {
      close.style.setProperty('display', 'none', 'important');
      return;
    }
    close.style.setProperty('display', 'flex', 'important');
  }

  function ensureCloseOnModalRoot(modal, close) {
    if (modal && close && close.parentElement !== modal) {
      modal.appendChild(close);
    }
  }

  function getMobileNavBandTop(modal) {
    var header = document.getElementById('la-prescription-modal-header');
    if (!header) return null;

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var bandOffset = Math.max(8, vh * 0.04 - 20);
    return header.getBoundingClientRect().bottom + bandOffset;
  }

  function positionMobileCloseAlign(backEl, backTop, modal, contentBody) {
    if (!isMobileViewport() || !isGlassesHost()) {
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    ensureCloseOnModalRoot(modal, close);
    syncCloseChrome();

    var navTop = typeof backTop === 'number' ? backTop : getMobileNavBandTop(modal);
    if (navTop === null) {
      return;
    }

    var refHeight = backEl ? backEl.getBoundingClientRect().height || 34 : 34;
    var closeHeight = close.getBoundingClientRect().height || 34;
    var alignedTop = navTop + (refHeight - closeHeight) / 2;
    var contentRight = getStepContentRight(modal, contentBody);

    close.style.setProperty('position', 'fixed', 'important');
    close.style.setProperty('top', alignedTop + 'px', 'important');
    close.style.setProperty('z-index', '100003', 'important');

    if (contentRight !== null) {
      var closeWidth = close.getBoundingClientRect().width || 34;
      close.style.setProperty('left', contentRight - closeWidth + 'px', 'important');
      close.style.setProperty('right', 'auto', 'important');
    } else {
      close.style.removeProperty('left');
      close.style.setProperty('right', '16px', 'important');
    }
  }

  function restoreDesktopClosePosition() {
    restoreClosePosition();
  }

  function restoreDesktopCloseChrome() {
    restoreCloseChrome();
  }

  function syncDesktopCloseChrome() {
    syncCloseChrome();
  }

  function getStepContentRight(modal, contentBody) {
    var cardRect = getColorStepCardRect(contentBody);
    if (cardRect) {
      return cardRect.right;
    }

    if (isMobileViewport()) {
      var reviewRect = getReviewCardRect(modal);
      if (reviewRect) {
        return reviewRect.right;
      }
    }

    var titleEl = getStepTitleElement(modal);
    if (titleEl) {
      var titleRect = titleEl.getBoundingClientRect();
      if (titleRect.width > 0) {
        return titleRect.right;
      }
    }

    if (!contentBody) {
      return null;
    }

    var bodyRect = contentBody.getBoundingClientRect();
    if (bodyRect.width <= 0) {
      return null;
    }

    var paddingRight = parseFloat(window.getComputedStyle(contentBody).paddingRight) || 0;
    return bodyRect.right - paddingRight;
  }

  function positionDesktopCloseAlign(backEl, backTop, modal, contentBody) {
    if (isMobileViewport() || !backEl) {
      return;
    }

    var close = getModalClose();
    if (!close) {
      return;
    }

    syncDesktopCloseChrome();

    var backHeight = backEl.getBoundingClientRect().height || 20;
    var closeHeight = close.getBoundingClientRect().height || 36;
    var alignedTop = backTop + (backHeight - closeHeight) / 2;
    var contentRight = getStepContentRight(modal, contentBody);

    close.style.setProperty('top', alignedTop + 'px', 'important');

    if (contentRight !== null) {
      var closeWidth = close.getBoundingClientRect().width || 36;
      close.style.setProperty('left', contentRight - closeWidth + 'px', 'important');
      close.style.setProperty('right', 'auto', 'important');
    }
  }

  function positionGusaBack(custom, modal) {
    var header = document.getElementById('la-prescription-modal-header');
    var contentBody = modal.querySelector('.la-prescription-modal-content-body');
    if (!custom || !header) return;

    if (shouldHideChromeForTransitionsDrawer()) {
      custom.style.setProperty('display', 'none', 'important');
      syncCloseChrome();
      return;
    }

    custom.style.removeProperty('display');

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var bandOffset = Math.max(8, vh * 0.04 - 20);
    var headerRect = header.getBoundingClientRect();
    var bandTop = headerRect.bottom + bandOffset;
    var top = bandTop;

    var isMobile = isMobileViewport();
    var titleEl = getStepTitleElement(modal);

    if (isMobile) {
      /* Mobile — back sits in the header band row; title-based top is desktop-only. */
    } else if (titleEl) {
      var titleRect = titleEl.getBoundingClientRect();
      var backHeight = custom.getBoundingClientRect().height || 20;
      top = Math.max(headerRect.bottom + 4, titleRect.top - backHeight - 20);
    }

    custom.style.setProperty('top', top + 'px', 'important');

    var left = 18;
    var cardRect = getColorStepCardRect(contentBody);
    var reviewRect = isMobile ? getReviewCardRect(modal) : null;

    if (contentBody) {
      var bodyRect = contentBody.getBoundingClientRect();
      if (bodyRect.width > 0) {
        if (reviewRect) {
          left = getMobileInsetLeft(modal, contentBody, reviewRect);
        } else if (cardRect) {
          left = cardRect.left;
        } else if (titleEl) {
          left = titleEl.getBoundingClientRect().left;
        } else {
          left = getFallbackLeft(modal, bodyRect, isMobile);
        }
      }
    }

    custom.style.setProperty('left', left + 'px', 'important');

    syncColorStepTitleAlign(modal, contentBody);

    if (isMobile) {
      positionMobileCloseAlign(custom, top, modal, contentBody);
    } else {
      positionDesktopCloseAlign(custom, top, modal, contentBody);
    }
  }

  function ensureCustomBack(modal, nativeBack) {
    var custom = modal.querySelector(':scope > .ciw-la-gusa-back-btn');
    if (!custom) {
      custom = document.createElement('button');
      custom.type = 'button';
      custom.className = 'ciw-la-gusa-back-btn';
      custom.textContent = '< Back';
      custom.setAttribute('aria-label', 'Back');
      custom.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (nativeBack && !nativeBack.disabled) {
          nativeBack.click();
        }
      });
      modal.appendChild(custom);
    }
    return custom;
  }

  var gusaSyncQueued = false;

  function queueSyncGusaBack() {
    if (gusaSyncQueued) return;
    gusaSyncQueued = true;
    window.requestAnimationFrame(function () {
      gusaSyncQueued = false;
      syncGusaBack();
    });
  }

  function syncGusaBack() {
    if (!isGlassesHost() || !document.body.classList.contains('la-modal-open')) {
      teardownGusaBack();
      return;
    }

    var modal = getModal();
    if (!modal) return;

    var contentBody = modal.querySelector('.la-prescription-modal-content-body');

    if (!isColorStepActive()) {
      clearColorStepTitleAlign(contentBody);
    }

    syncCloseChrome();

    var nativeBack = getNativeBack(modal);
    if (!nativeBack || nativeBack.disabled) {
      restoreNativeBack(nativeBack);
      removeCustomBack(modal);
      if (isMobileViewport()) {
        positionMobileCloseAlign(null, getMobileNavBandTop(modal), modal, contentBody);
      } else {
        restoreClosePosition();
      }
      return;
    }

    hideNativeBack(nativeBack);
    var custom = ensureCustomBack(modal, nativeBack);
    positionGusaBack(custom, modal);
    startObserve();
  }

  function stopPoll() {
    if (!pollId) return;
    window.clearInterval(pollId);
    pollId = null;
  }

  function startPoll() {
    if (pollId) return;
    pollId = window.setInterval(syncGusaBack, 250);
  }

  function stopObserve() {
    if (!modalObserver) return;
    modalObserver.disconnect();
    modalObserver = null;
  }

  function startObserve() {
    if (modalObserver) return;
    var modal = getModal();
    if (!modal || typeof MutationObserver === 'undefined') return;

    modalObserver = new MutationObserver(function () {
      queueSyncGusaBack();
    });
    modalObserver.observe(modal, { childList: true, subtree: true });
  }

  function teardownGusaBack() {
    var modal = getModal();
    clearColorStepTitleAlign(
      modal && modal.querySelector('.la-prescription-modal-content-body')
    );
    restoreNativeBack(getNativeBack(modal));
    removeCustomBack(modal);
    restoreCloseChrome();
    stopPoll();
    stopObserve();
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }
  }

  function onModalOpen() {
    window.setTimeout(syncGusaBack, 0);
    window.setTimeout(syncGusaBack, 150);
    startPoll();
    startObserve();
    if (!resizeHandler) {
      resizeHandler = function () {
        syncGusaBack();
      };
      window.addEventListener('resize', resizeHandler);
    }
  }

  function bind() {
    document.addEventListener('LensAdvizor:selectLensModal:open', onModalOpen);
    document.addEventListener('LensAdvizor:selectLensModal:close', teardownGusaBack);

    [
      'LensAdvizor:prescriptionTypes:rendered',
      'LensAdvizor:lens:rendered',
      'LensAdvizor:lensOptions:rendered',
      'LensAdvizor:addOns:rendered',
      'LensAdvizor:review:rendered',
      'LensAdvizor:render:submissionMethods',
      'LensAdvizor:render:manualEntryForm',
      'LensAdvizor:render:uploadForm',
      'LensAdvizor:render:readingForm',
      'ciw-la-lens-color:continue-sync',
      'ciw-la-lens-color:selection-changed'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        window.setTimeout(syncGusaBack, 0);
        window.setTimeout(syncGusaBack, 150);
      });
    });

    if (document.body.classList.contains('la-modal-open') && isGlassesHost()) {
      onModalOpen();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
